/**
 * eslint-disable @typescript-eslint/no-unsafe-assignment
 *
 * @format
 */

import {
	Box,
	Container,
	Heading,
	HStack,
	Text,
	useBreakpointValue,
	VStack,
} from '@chakra-ui/react';
import Layout from '../../components/Layout';
import getFooter from '../../lib/api/acf/footer';
import getMainMenu from '../../lib/api/acf/mainMenu';
import mappingFooter from '../../patterns/Footer/mappingFooter';
import mappingMainMenu from '../../patterns/MainMenu/mappingMainMenu';
import {textStyles} from '../../styles/js/textStyles';
import {PackageCards} from '../../components/WhyJoin/PackageCards';

const MobileCardContainer = () => (
	<VStack spacing={6} my={6}>
		<PackageCards />
	</VStack>
);

const DesktopCardContainer = () => (
	<HStack spacing={6} my={6} alignItems='space-evenly'>
		<PackageCards />
	</HStack>
);

// eslint-disable-next-line react/prop-types
const JoinTheAssc = ({seo, mainMenu, footer}) => {
	const CardStack = useBreakpointValue(
		{
			base: MobileCardContainer,
			md: DesktopCardContainer,
		},
		{ssr: true},
	);
	return (
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		<Layout seo={seo} mainMenu={mainMenu} footer={footer}>
			<Container maxW='container.xl'>
				<Box my={20} maxW={'75%'}>
					<Heading sx={textStyles.display3LeftDark} as='h1' mb={6}>
						Become an ASSC member
					</Heading>
					<Text sx={textStyles.paragraph1LeftDark} mb={12}>
						Whether you manage one self-catering property, a portfolio of
						properties or an agency, or operate as a trade supplier, we welcome
						you to join the ASSC.
					</Text>
				</Box>
				{CardStack && <CardStack />}
			</Container>
		</Layout>
	);
};

export async function getStaticProps() {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	let mainMenu = await getMainMenu();
	mainMenu = mappingMainMenu(mainMenu);

	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	let footer = await getFooter();
	footer = mappingFooter(footer);

	return {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		props: {seo: {title: 'Join the ASSC'}, mainMenu, footer},
	};
}

export default JoinTheAssc;
